var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-resume" }, [
    _c(
      "div",
      { staticClass: "resume" },
      _vm._l(_vm.Items, function(item) {
        return _c("div", { key: item.title, staticClass: "item" }, [
          _c("div", { staticClass: "item-title" }, [
            _c("i", { class: item.icon }),
            _c("h4", [_vm._v(_vm._s(item.title))])
          ]),
          _c(
            "div",
            {
              staticClass: "item-value",
              class: { down: item.pourcentage < 0, up: item.pourcentage > 0 }
            },
            [
              _c("h5", {
                domProps: { innerHTML: _vm._s(_vm.numberSpacing(item.value)) }
              }),
              _c("i", { staticClass: "fa-solid fa-arrow-right" }),
              _c("p", [
                _vm._v(_vm._s(item.pourcentage)),
                _c("span", { staticClass: "pourcentage" }, [_vm._v("%")])
              ])
            ]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }